import I from '@/components/I'
import {SUCCESS_CODE} from '@/constants'
import {GetServerSideProps} from 'next'
import {useEffect, useState, useRef, ReactEventHandler} from 'react'
//@ts-ignore
import {useLottie} from '@/hooks/useLottie'
import classNames from 'classnames'
import {useActivity} from '@/pages/activity/tenyears'
import {ActivityId, CombineImage_Map, IMAGE_MAP, Lottie_Map, TenAcTitle} from '@/constants/activityCdn'
import TitleBar from '@/components/TitleBar'
import {Swiper, Toast} from 'gotu-ui'
import {DoMissionRes, Mission, SubActivityModule} from '@/service/activity'
import {useUaParam} from '@/pages/_app'
import {openWindow} from '@/plugins/bridge'
import {useCombine} from '@/pages/activity/tenyears/combine'
import {haboClickReport} from '@/plugins/habo'

const styles = require('./style.module.less')
interface ModuleProps {
  visible: boolean
  data?: DoMissionRes | null,
  close: () => void
}

const RewardPopup = (props: ModuleProps) => {
    const {
        visible,
        data,
        close,
    } = props

    const {
        activeFraId,
        setActiveFraId,
        setData,
        getData,
    } = useCombine()
    const {isApp, source} = useUaParam()
    const lottieRef = useRef<any>(null)
    const timer = useRef<any>(null)
    const [options, setOptions] = useState({
        loop: true,
        autoplay: true,
        path: Lottie_Map.popup,
        direction: 1,
        speed: 1,
    } as any)
    const [anim, loadFinish, loadLottie, animRef] = useLottie(lottieRef, options)
    useEffect(() => {
        if (visible) {
            rewardInfo && haboClickReport('十周年奖励弹窗曝光', {source, giftname: rewardInfo.rewardId, activity_id: ActivityId})
            anim?.goToAndPlay(0, true)
            // timer.current = setInterval(() => {
            //     animRef.current?.goToAndPlay(0, true)
            // }, 2500)
        } else {
            clearInterval(timer.current)
        }
    }, [visible])
    useEffect(() => {
        if (data) {
            loadLottie()
        }
    }, [data])
    if (!data) return null

    const {
        rewardInfo,
        congratulationText,
        description,
        isNew,
    } = data

    const getReward = () => {
        // 新碎片 需要触发动画，在main组件中手动修改周年接口的值
        if (rewardInfo.rewardType === 1 && isNew) {
            close()
            setActiveFraId(rewardInfo.rewardId)
        } else {
            close()
            getData()
            Toast.show('奖励已发放，详见系统消息')
        }
    }
    return (
        <div
            className={classNames({[styles.reward]: true, [styles.visible]: visible})}
        >
            <div className={styles.bg}></div>
            <div className={styles.content}>
                <I
                    src={CombineImage_Map.popup_title}
                    width={336}
                    height={150}
                ></I>
                <div className={styles.box}>
                    <div
                        className='center w180% z-1'
                        ref={lottieRef}
                    ></div>
                    {
                        isNew && (
                            <I
                                className={styles.new}
                                src={CombineImage_Map.new_icon}
                                width={104}
                                height={104}
                            ></I>
                        )
                    }
                    <I
                        className='poa t0 l0 z1'
                        src={CombineImage_Map.popup_bg}
                        width={278}
                        height={283}
                    ></I>
                    <div className='poa z2 mt-20 fc'>
                        <I
                            className='mt'
                            src={rewardInfo.rewardImgUrl}
                            width={180}
                            height={180}
                        ></I>
                        <div className='por tcenter'>
                            <div className='fs18 fw600 lh26 #2C2E40'>{ rewardInfo.rewardName}</div>
                            <div className='fs12 fw400 lh18 #9698A1 mt7'>{ description}</div>
                        </div>
                    </div>

                </div>
                <div
                    className={styles.btn}
                    onClick={getReward}
                >
                    {/* 1-碎片奖励 */}
                    { (rewardInfo.rewardType === 1 && isNew) ? '去拼蛋糕' : '开心收下' }
                </div>

            </div>
        </div>
    )
}

export default RewardPopup
